/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nav-content-wrapper[_ngcontent-%COMP%]{display:flex;height:100%}.nav-content-wrapper[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]{flex:1;overflow:auto;position:relative}.loader[_ngcontent-%COMP%]{position:absolute;display:block;left:0;right:0;z-index:1000}"];
export { styles as styles };
